import { render, staticRenderFns } from "./WorkInfo.vue?vue&type=template&id=cd88ae24&scoped=true"
import script from "./WorkInfo.vue?vue&type=script&lang=js"
export * from "./WorkInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd88ae24",
  null
  
)

export default component.exports